import React, { Component } from "react";
import LiveContentTest from "./components/liveContentTest";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import UserTest from "./components/userTest";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class App extends Component {
  state = {};

  render() {
    return (
      <div className="App">
        <ToastContainer />
        <Switch>
          <Route path="/react/great">
            <UserTest />
          </Route>
          <Route exact path="/react">
            <LiveContentTest />
          </Route>
          <Route exact path="/paymentssss/">
            <h2>Here are some payment details</h2>
          </Route>
          <Route exact path="/cashmoney/">
            <h2>We'll add more cashmoney details soon, with React</h2>
          </Route>
        </Switch>
      </div>
    );
  }
}

export default App;
